import { FC, PropsWithChildren } from "react";
import { RootState } from "store/types";
import { connect } from "react-redux";
import { Roles, UserData } from "store/reducers/session/types";

interface StateProps {
  user: UserData | null;
}

interface OwnProps {
  roles: Roles[];
}

interface AppHeaderProps extends StateProps, OwnProps, PropsWithChildren<{}> {}

const ShowForRoles: FC<AppHeaderProps> = ({ children, user, roles }) => {
  if (user && roles.includes(user.role)) {
    return <>{children}</>;
  }
  return <></>;
};

const mapStateToProps = (state: RootState): StateProps => ({
  user: state.session.user
});

export default connect<StateProps, {}, OwnProps, RootState>(
	mapStateToProps,
)(ShowForRoles);